import axios from '../utils/axios';
import authService from '../services/authService';
import userService from '../services/userService';

export const LOGIN_REQUEST = '@account/login-request';
export const LOGIN_SUCCESS = '@account/login-success';
export const LOGIN_FAILURE = '@account/login-failure';
export const SILENT_LOGIN = '@account/silent-login';
export const LOGOUT = '@account/logout';
export const REGISTER = '@account/register';
export const UPDATE_PROFILE = '@account/update-profile';

export function login(customer, email, password) {
  return async (dispatch) => {
    try {
      dispatch({ type: LOGIN_REQUEST });

      const token = await authService.loginWithEmailAndPassword(customer, email, password);

      const user = await authService.getUserByToken();

      dispatch({
        type: LOGIN_SUCCESS,
        payload: {
          user,
          customer
        }
      });
    } catch (error) {
      dispatch({ type: LOGIN_FAILURE });
      throw error;
    }
  };
}

export function setUserData(user) {
  return (dispatch) => dispatch({
    type: SILENT_LOGIN,
    payload: {
      user
    }
  });
}

export function logout() {
  return async (dispatch) => {
    authService.logout();

    dispatch({
      type: LOGOUT
    });
  };
}

export function register() {
  return true;
}

export function updateProfile(id, update) {
  return async (dispatch) => {
    const response = await userService.update(id, update);
    dispatch({
      type: UPDATE_PROFILE,
      payload: response.data
    });
  };
}
